import corporateTransformer from '../../transformers/corporate';
import tableUtil from '../../utils/table';
import axios from 'axios';

export default (params) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'organizations', { params })
      .then(({ data }) => {
        if (params.page || params.per_page) {
          let dataRes = {};
          if (data.data) {
            dataRes.data = corporateTransformer.fetchCollection(data.data);
          }
          dataRes.meta = data.pagination ? data.pagination : tableUtil.mockupMeta(dataRes.data.length);
          resolve(dataRes);
        } else {
          resolve(corporateTransformer.fetchCollection(data.data));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
